import { Resource } from "../resource/resource.model";
import { AIPreferencePage } from '../ai-preference-page/ai-preference-page.model';
import { AIReportResponse } from '../ai-report-response/ai-report-response.model';

export class AIResponseModel extends Resource {
    intent: string;
    data: any;
    
}

export type AIResponse = ReportResponse | PageResponse;

export interface BaseAIResponse extends Resource {
    intent: 'generate_report' | 'create_page';
}

export interface ReportResponse extends BaseAIResponse {
    intent: 'generate_report';
    data: AIReportResponse;
}

export interface PageResponse extends BaseAIResponse {
    intent: 'create_page';
    data: AIPreferencePage;
}

export function isReportResponse(res: AIResponse): res is ReportResponse {
    return res.intent === 'generate_report';
}

export function isPageResponse(res: AIResponse): res is PageResponse {
    return res.intent === 'create_page';
}
